import script from "./fieldOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./fieldOrder.vue?vue&type=script&setup=true&lang=js"

import "./fieldOrder.vue?vue&type=style&index=0&id=667d2c23&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-667d2c23"]])

export default __exports__